import React from 'react';
import { MenuItem, Typography } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { usePanierPay } from '@europrocurement/l2d-modules/modules/Paiement';

export type MenuGeneratePaymentLinkType = {
    id: number;
};
export const MenuGeneratePaymentLink: React.FunctionComponent<MenuGeneratePaymentLinkType> =
    function ({ id }) {
        // Methods to implements
        const { navigateFacturePay } = usePanierPay();
        return (
            <MenuItem
                sx={{ gap: '4px' }}
                onClick={() => {
                    navigateFacturePay([id as unknown as number]);
                }}
            >
                <FaOptionIcon
                    icon={['fasl', 'credit-card']}
                    color="text.gris70"
                />
                <Typography sx={{ color: 'text.primary' }}>Générer un lien de paiement</Typography>
            </MenuItem>
        );
    };
